















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { CustomerV3 as Customer } from '@/zenky/interfaces/customers/Customer';
import { SubmitOrderCustomer } from '@/zenky/interfaces/orders/PostRequests';
import { Omit } from 'lodash';
import SelectField from '@/components/forms/fields/common/SelectField.vue';
import FormFieldOption from '@/zenky/forms/interfaces/FormFieldOption';
import { randomId } from '@/helpers';
import Gender from '@/zenky/interfaces/customers/Gender';
import { assertNever } from '@/helpers/utils';
import { ValidationObserver, validate } from 'vee-validate';
import createCleaveTransformer from '@/helpers/cleave';

type CustomerInputs = Omit<Required<SubmitOrderCustomer>, 'id' | 'gender'>
  & Pick<SubmitOrderCustomer, 'gender'>;

export type NewCustomerChangeEvent = [
  CustomerSection['newCustomer'], // New value
  keyof Exclude<CustomerSection['newCustomer'], null>, // What changed
];

const birthDateUtils = {
  api2Input(str: Exclude<SubmitOrderCustomer['birth_date'], undefined>): string {
    return `${str.slice(8, 10)}.${str.slice(5, 7)}.${str.slice(0, 4)}`;
  },
  pattern: ['d', 'm', 'Y'],
  delimiter: '.',
};

@Component({
  components: { SelectField },
})
export default class CustomerSection extends Vue {
  @Prop({ required: true }) readonly orderCustomer!: Customer | null;
  @Prop({ required: true }) newCustomer!: CustomerInputs | null; // if it's not `null`, we're in customer creation mode.
  private readonly randomId = randomId;
  private readonly birthDateUtils = birthDateUtils;

  private readonly cleaveTransformBirthDateInput = createCleaveTransformer({
    date: true,
    datePattern: birthDateUtils.pattern,
    delimiter: birthDateUtils.delimiter,
  });

  get inputVals(): Omit<CustomerInputs, 'phone_country'> {
    if (this.newCustomer !== null) {
      return this.newCustomer;
    }
    if (this.orderCustomer === null) {
      throw new Error('Attempted to get field values while both `newCustomer` and `orderCustomer` are `null`');
    }
    return {
      phone: this.orderCustomer.phone.e164,
      first_name: this.orderCustomer.first_name,
      last_name: this.orderCustomer.last_name,
      gender: this.orderCustomer.gender.id,
      birth_date: this.orderCustomer.birth_date === null
        ? ''
        : birthDateUtils.api2Input(this.orderCustomer.birth_date.datetime_utc),
    };
  }
  get genderOptions(): FormFieldOption[] {
    return Object.values(Gender).map((gender: Gender) => {
      let label: string;
      switch (gender) {
        case Gender.FEMALE: label = 'Женский'; break;
        case Gender.MALE: label = 'Мужской'; break;
        case Gender.OTHER: label = 'Другой'; break;
        // `label = 'asd'` is a workaround to suppress "used before being initialized".
        default: assertNever(gender); label = 'asd';
      }
      return { value: gender, label };
    });
  }
  onInput<T extends keyof Exclude<CustomerSection['newCustomer'], null>>(
    field: T,
    value: Exclude<CustomerSection['newCustomer'], null>[T],
  ) {
    if (this.newCustomer === null) {
      throw new Error('Ran input handler while not in customer creation mode');
    }
    const payload: NewCustomerChangeEvent = [
      {
        ...this.newCustomer,
        [field]: value,
      },
      field,
    ];
    this.$emit('change:new-customer', ...payload);
  }
}
